import { ApiPermissions } from "../../cefi";

export enum CefiWithdrawalsAndDepositHelpUrls {
  BINANCE = "https://www.binance.com/en/fee/cryptoFee",
  COINBASE = "https://help.coinbase.com/en/exchange/trading-and-funding/funding-your-account-with-usd",
  KRAKEN = "https://support.kraken.com/hc/en-us/articles/360000292886-Cryptocurrency-deposit-fees-and-minimums",
  GATEIO = "https://coinmarketfees.com/exchange/gate-io",
  BITFINEX = "https://www.bitfinex.com/fees/",
  KUCOIN = "https://www.kucoin.com/support/900002595503",
  BYBIT = "https://www.bybit.com/en-US/help-center/bybitHC_Article?id=900004850026",
}

export enum CefiWithdrawalsFeeLinks {
  KRAKEN = "https://support.kraken.com/hc/en-us/articles/360000767986-Cryptocurrency-withdrawal-fees-and-minimums",
}

export type SdkConfig = {
  supported_cexs: string[];
  two_keys_cexs: string[];
  password_cexs: string[];
  uid_cexs: string[]; // CEXs that require an uid to login (the uid refers to the API key name)
  ip_whitelist_cexs: string[];
  ip_whitelist_addresses: string[];
  ip_whitelist_scopes_by_cex: Record<string, ApiPermissions[]>;
  /** Induced permissions by CEX.
   * @example // The following line implies that if the user wants the WITHDRAW permission, we need to force the TRADE permission as well
   * ApiPermissions.WITHDRAW: [ApiPermissions.TRADE] */
  induced_permissions_by_cex: Record<string, Partial<Record<ApiPermissions, ApiPermissions[]>>>;
  /** Field representing CEXs with a whitelisting system
   * @property exchangeId - The exchange identifier
   * @property provideWhitelistedAddresses - If the CEX provide an endpoint to get the whitelisted addresses
   */
  address_whitelist_cexs: {
    exchangeId: string;
    provideWhitelistedAddresses: boolean;
  }[];
  cexs_with_sub_accounts: string[];
  affiliation_links: {
    [key: string]: string;
  };
  api_management_links: {
    [key: string]: string;
  };
  address_management_urls: {
    [key: string]: string;
  };
  networks_under_maintenance: {
    [key: string]: string;
  };
  send: {
    [key: string]: boolean;
  };
  trade: {
    [key: string]: boolean;
  };
  limit_trade: {
    [key: string]: boolean;
  };
  receive: {
    [key: string]: boolean;
  };
  trade_and_send: {
    [key: string]: boolean;
  };
  internal_transfer: {
    [key: string]: boolean;
  };
  trade_square: {
    [key: string]: boolean;
  };
  send_under_maintenance: {
    [key: string]: boolean;
  };
  trade_under_maintenance: {
    [key: string]: boolean;
  };
  trade_and_send_under_maintenance: {
    [key: string]: boolean;
  };
  receive_under_maintenance: {
    [key: string]: boolean;
  };
  send_minimum_help_urls: {
    [key: string]: CefiWithdrawalsFeeLinks;
  };
  receive_minimum_help_urls: {
    [key: string]: CefiWithdrawalsAndDepositHelpUrls;
  };
  send_cexs_appending_fees_to_amount: string[];
  enable_sentry: boolean;
  enable_exchange_local_availibility: boolean;
  oauth_login_cexs: string[];
  pkce_flow_cexs: string[];
  fast_api_cexs: string[];
  // CEXs that support OAuth and API keys
  hybrid_cexs: {
    [cex: string]: {
      oauth: ApiPermissions[];
      api_keys: ApiPermissions[];
    };
  };
  require_email_confirmation?: string[];
  uninstall_url_fallback?: string;
  serverside_allowed_origins?: Record<string, string>;
  not_connected_identifier?: string;
  website_homelink_identifier?: string;
  support_verify_kyc: {
    [key: string]: boolean;
  };
};
